function reorder(repeatable) {
	var items = $(repeatable).children('tr');

	// Clean up CKEditor manually, editorInstance.destroy is broken
	$(repeatable).find('textarea.editor').each(function(i, elem) {
		var editorInstance = CKEDITOR.instances[$(elem).attr('id')];
		if (editorInstance) {
			var data = editorInstance.getData();
			editorInstance.removeAllListeners();
			editorInstance.destroy();
			$(elem).val(data);
		}
	});
	$(repeatable).find('.cke').remove();

	for (var i = 0; i < items.length; i++) {

		// Update inputs
		$(items[i]).find('input, select, textarea').each(function(j, input) {
			var id = $(input).attr('id');
			var name = $(input).attr('name');
			if (id) {
				var newid = id.slice(0, id.lastIndexOf('[')) + '[' + i + ']';

				$(input).attr("id", newid).attr("name", name.replace(id, newid));
				$(input).siblings('[data-field="'+id+'"]').attr("data-field", name.replace(id, newid));
			}
			else {
				var newid = name.slice(0, name.lastIndexOf('[')) + '[' + i + ']';
				$(input).attr("name", name.replace(name, newid));
			}
		});
		// Update labels
		$(items[i]).find('label[for]').each(function(j, label) {
			var id = $(label).attr('for');

			id = id.slice(0, id.lastIndexOf('[')) + '[' + i + ']';

			$(label).attr("for", id);
		});
	}

	// remake CKEditors.
	ckeditor($(repeatable).find('textarea.editor'));
}

function autocomplete(elems) {
	$(elems).each(function(i, elem) {
		$(elem).autocomplete({
			source: function(request, response) {
				$.get(ajaxUrl + '/autocomplete/' + $(elem).attr('data-meta-id') + '/' + request.term, function(data) {
					response(JSON.parse(data));
				});
			}
		});
	});
}

function tagit(elems) {
	$(elems).each(function(i, elem) {
		$(elem).tagit({
			allowSpaces: true,
			autocomplete: {
				source: function(request, response) {
					$.get(ajaxUrl + '/tags/' + $(elem).attr('data-meta-id') + '/' + request.term, function(data) {
						response(JSON.parse(data));
					});
				}
			}
		});
	});
}

function multiselect(elems) {
	$(elems).each(function(i, elem) {
		$(elem).multiselect({
			header: false,
			selectedList: 4
		});

	});
}

function datepicker(elems) {
	$(elems).each(function(i, elem) {
		$(elem).datepicker();
	});
}

CKEDITOR.config.extraPlugins = 'media';
CKEDITOR.config.allowedContent = true;
CKEDITOR.config.skin = 'moonocolor';

function ckeditor(elems) {
	$(elems).each(function(i, elem) {
		if ($(elem).hasClass('simple')) {
			CKEDITOR.replace(elem, {
				toolbarGroups: [
					{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
					{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
					{ name: 'links', groups: [ 'links' ] },
					{ name: 'insert', groups: [ 'insert' ] },
					{ name: 'forms', groups: [ 'forms' ] },
					{ name: 'tools', groups: [ 'tools' ] },
					{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
					{ name: 'others', groups: [ 'others' ] },
					{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
					{ name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
					{ name: 'styles', groups: [ 'styles' ] },
					{ name: 'colors', groups: [ 'colors' ] }
				],
				removeButtons: 'Underline,Subscript,Superscript,Media,Image,Table,HorizontalRule,SpecialChar,Maximize,Indent,Outdent,Blockquote,Styles,Format'
			});
		}
		else {
			CKEDITOR.replace(elem, { removeButtons: 'Image,About'});
		}
	});
}

function toggle(elems) {
	$(elems).click(function() {
		$(this).siblings('.toggle-body').toggle();
	})
}

function media(elems) {
	$(elems).click(function(e) {
		e.preventDefault();
		$('.lightbox-overlay').fadeIn();

		var dataType = $(e.target).attr('data-type');

		$.get(ajaxUrl+'/media/'+(dataType || 'images')+'/'+(dataType || 'all'), function(data) {
			// Define what to do with images once selected... Could be simplified
			var fieldId = $(e.target).attr('data-field');
			var size = $(e.target).attr('data-size');
			$('.lightbox-content').html(data);
			$('.lightbox-content').off('click', '.media a').on('click', '.media a', function(e) {
				e.preventDefault();
				if (dataType == 'images') {
					$.get(ajaxUrl+'/crop/'+$(this).attr('data-media')+'/'+(size || '0x0'), function(data) {
						$('.lightbox-content').html(data);
						$('#crop_form').submit(function(e) {
							e.preventDefault();
							$.post(ajaxUrl+'/crop', $(this).serialize(), function(data) {
					            var json = JSON.parse(data);
					            showPreview(fieldId, json.id, json.url, json.embed, json.crop);
							});
						});
					});
				}
				else {
					showPreview(fieldId, $(this).attr('data-media'), $(this).attr('data-url'), $(this).attr('data-embed'));
				}
			});
			$('.lightbox-content').off('submit', '#upload_form').on('submit', '#upload_form', function(e) {
				e.preventDefault();
				$.post(ajaxUrl+'/upload', $(this).serialize(), function(data) {
		            var json = JSON.parse(data);
					if (dataType == 'images') {
						$.get(ajaxUrl+'/crop/'+json.id+'/'+(size || '0x0'), function(data) {
							$('.lightbox-content').html(data);
							$('#crop_form').submit(function(e) {
								e.preventDefault();
								$.post(ajaxUrl+'/crop', $(this).serialize(), function(data) {
						            var json = JSON.parse(data);
						            showPreview(fieldId, json.id, json.url, json.embed, json.crop);
								});
							});
						});
					}
					else {
						showPreview(fieldId, json.id, json.url, json.embed);
					}
				});
			});

			$('.lightbox').fadeIn();
		});
	});
}

function deleteMedia(elems) {
	$(elems).click(function(e) {
		e.preventDefault();
		hidePreview( $(e.target).attr('data-field') );
	})
}

function showPreview(fieldId, mediaId, url, embed, crop) {
	var field = $('[id="' + fieldId + '"');
	if (crop != undefined) {
		field.val(mediaId+'|'+crop);
	}
	else {
		field.val(mediaId);
	}
	field.siblings('.old-image[data-field="'+fieldId+'"]').children().not('label').remove();
	field.siblings('.old-image[data-field="'+fieldId+'"]').prepend(embed)
		.children('img').attr('src', url);

	field.siblings('.old-image[data-field="'+fieldId+'"]').show();
	field.siblings('.old[data-field="'+fieldId+'"]').show();
	field.siblings('.new[data-field="'+fieldId+'"]').hide();

	$('.lightbox-overlay').fadeOut();
	$('.lightbox').fadeOut();
}

function hidePreview(fieldId) {
	var field = $('[id="' + fieldId + '"');
	field.val(0);

	field.siblings('.old-image[data-field="'+fieldId+'"]').hide();
	field.siblings('.old[data-field="'+fieldId+'"]').hide();
	field.siblings('.new[data-field="'+fieldId+'"]').show();
}


$(document).ready(function() {
	var repeatables = [];

	$('.repeater').click(function() {
		// find table
		var table = $(this).siblings('.repeatable');

		// copy tr from thead
		var tr = table.children('thead').children('tr').last().clone();

		// Reset jquery widgets
		tr.find('.cke').remove();
		autocomplete(tr.find('.autocomplete'));
		tagit(tr.find('.tags'));
		datepicker(tr.find('.date'));
		multiselect(tr.find('.multiselect').show());
		toggle(tr.find('.toggle a'));
		media(tr.find('.add-media'));
		deleteMedia(tr.find('.delete-media'));

		// append to tbody
		table.children('tbody').append(tr);
		reorder(table.children('tbody'));

		// Set up delete
		tr.find('.delete').click(function() {
			tr.remove();
			reorder(tbody);
		});
	});

	$('.repeatable .delete').click(function() {
		// find tbody
		var tbody = $(this).closest('.repeatable tbody');

		$(this).closest('tr').remove();

		reorder(tbody);
	});

	$('.repeatable tbody').sortable({
		helper: function(e, tr) {
			var $originals = tr.children();
			var $helper = tr.clone();
			$helper.children().each(function(index) {
				// Set helper cell sizes to match the original sizes
				$(this).width($originals.eq(index).width());
			});
			return $helper;
		},
		placeholder: "placeholder",
		cursor: "move",
		stop: function(event) {
		  reorder(event.target);
		}
	});

	$('.sortable tbody').sortable({
		helper: function(e, tr) {
			var $originals = tr.children();
			var $helper = tr.clone();
			$helper.children().each(function(index) {
				// Set helper cell sizes to match the original sizes
				$(this).width($originals.eq(index).width());
			});
			return $helper;
		},
		placeholder: "placeholder",
		cursor: "move",
		stop: function(event) {
			var pages = [];
			var message = $(event.target).closest('.content').siblings('.message');
			if (message.length == 0) {
				message = $('<p class="message"></p>').insertAfter($(event.target).closest('.content'));
			}
			$(message).html('Saving...');
			var trs = $(event.target).children('tr');

			if ($(event.target).parent().hasClass('related-fields')) {
				for (var i = 0; i < trs.length; i++) {
					var url = ajaxUrl+'/reorder-fields';
					pages.push($(trs[i]).attr('data-fieldid'));
				}
			}
			else {
				for (var i = 0; i < trs.length; i++) {
					var url = ajaxUrl+'/reorder';
					var parent = $(event.target).parent().attr('data-parent');
					if (parent) {
						url += '/'+parent
					}
					pages.push($(trs[i]).attr('data-pageid'));
				}
			}

			$.post(url, {
				'_token': ajaxToken,
				'pages[]': pages
			}, function() {
				message.html('Order saved.')
			});
		}
	});

	$('.sortable-field tbody').sortable({
		helper: function(e, tr) {
			var $originals = tr.children();
			var $helper = tr.clone();
			$helper.children().each(function(index) {
				// Set helper cell sizes to match the original sizes
				$(this).width($originals.eq(index).width());
			});
			return $helper;
		},
		placeholder: "placeholder",
		cursor: "move",
		stop: function(event) {
			var values = [];
			$(this).find('tr').each(function() {
				values.push($(this).attr('data-value'));
			});

			$('#'+$(this).parent().attr('data-id')).val(JSON.stringify(values));
		}
	});
	$('.sortable-field tbody').each(function() {
		var values = [];
		$(this).find('tr').each(function() {
			values.push($(this).attr('data-value'));
		});
		$('#'+$(this).parent().attr('data-id')).val(JSON.stringify(values));
	});

	$('.advanced-button').click(function(e) {
		e.preventDefault();
		$('.advanced-search-form').toggle();
	});

	media($('.add-media'));
	deleteMedia($('.delete-media'));

	$('.lightbox .close, .smallbox .close, .smallbox .cancel, .lightbox-overlay').click(function() {
		$('.lightbox-overlay').fadeOut();
		$('.lightbox').fadeOut();
		$('.smallbox').fadeOut();
	});

	$('.toggle-status').click(function(e) {
		e.preventDefault();
		var page = $(this);
		$.get(page.attr('href'), function(data) {
			page.html(data);
		});
	})

	$('#menu').slicknav({
		label: '',
		//duration: 100,
		//easingOpen: "easeOutBounce",
		prependTo:'#mobile_menu'
	});

	$('.accordion-toggle, .listing-toggle').on('click', function(event){
		event.preventDefault();
		// create accordion variables
		var accordion = $(this);
		var accordionContent = accordion.next();
		var accordionToggleIcon = $(this).children('.toggle-icon');

		// toggle accordion link open class
		accordion.toggleClass("open");
		// toggle accordion content
		accordionContent.slideToggle(250);

		// change plus/minus icon
		if (accordion.hasClass("open")) {
			accordionToggleIcon.html(function(index, html) {
				return html.replace("closed", "open");
			});
		} else {
			accordionToggleIcon.html(function(index, html) {
				return html.replace("open", "closed");
			});
		}
	});

	var href;

	function loadSection() {
		$('.editable-section').hide();
		if (document.location.hash) {
			href = document.location.hash
		}
		else {
			if ($('.section-link.error').length > 0) {
				href = $($('.section-link.error')[0]).attr('href');
			}
			else {
				href = $($('.section-link')[0]).attr('href');
			}
		}
		var section = $(href);
		section.show();
		$('#section-title').text(section.attr('data-header'));

		var next = $('aside [href="'+href+'"]').parent().next().find('.section-link').attr('href');
		if (next == undefined || next == '#related' || next == '#subpages' || next == '#drafts') {
			$('#continue').hide();
		}
		else {
			$('#continue').show();
		}

		$('.section-link').removeClass('active');
		$('[href="'+href+'"]').addClass('active');
	}

	window.onpopstate = loadSection;

	$('.section-link').click(function(event) {
		event.preventDefault();
		history.pushState({}, '', this.href);

		$('.editable-section').hide();
		href = $(this).attr('href');
		var section = $(href);
		section.show();
		$('#section-title').text(section.attr('data-header'));

		var next = $('aside [href="'+href+'"]').parent().next().find('.section-link').attr('href');
		if (next == undefined || next == '#related' || next == '#subpages' || next == '#drafts') {
			$('#continue').hide();
		}
		else {
			$('#continue').show();
		}

		$('.section-link').removeClass('active');
		$('[href="'+href+'"]').addClass('active');
	});

	$('#continue').click(function(event) {
		event.preventDefault();
		$('aside [href="'+href+'"]').parent().next().find('.section-link').click();
	});

	loadSection();

	function updatePermissions() {
		var role = $('#role').val();
		$('#permissions').find('.help-text').removeClass('active');
		$('.role-'+role).addClass('active');

		if (role == 0) {
			$('#permissions input[type="checkbox"]').prop('checked', false).prop('disabled', true);
		}
		else if (role == 4) {
			$('#permissions input[type="checkbox"]').prop('checked', true).prop('disabled', true);
		}
		else {
			$('#permissions [type="checkbox"]').prop('disabled', false);
			$('#permissions [type="checkbox"][value="3"]').each(function(i, elem) {
				if ($(elem).prop('checked')) {
					$(elem).parent().prev().find('input').prop('checked', true).prop('disabled', true);
				}
			});
		}
	}

	$('#permissions').change(updatePermissions);
	updatePermissions();

	$('.publish-form').on('change', '.page-type', function(event) {
		$.get(ajaxUrl + '/pageselect/' + $(this).val(), function(data) {
			var options = JSON.parse(data);
			$(event.target).closest('tr').find('.pages option').not('[disabled]').remove();
			for (val in options) {
				$(event.target).closest('tr').find('.pages').append('<option value='+val+'>'+options[val]+'</option>')
			}
			$(event.target).closest('tr').find('.pages').val(0).prop('disabled', false);
		});
	});

	$('.mc_template').change(function() {

		// Clean up CKEditor manually, editorInstance.destroy is broken
		$('.mc_content').each(function(i, elem) {
			var editorInstance = CKEDITOR.instances[$(elem).attr('id')];
			if (editorInstance) {
				editorInstance.removeAllListeners();
				editorInstance.destroy();
			}
		});
		$('#content').find('.cke').remove();
		$('.mc_label, .mc_content').remove();

		$.get(ajaxUrl + '/mailchimp/gettemplate/' + $(this).val(), function(data) {
			var sections = JSON.parse(data);
			for (section in sections) {
				$('#content').append('<label class="mc_label" for="content_'+section+'">'+
					section.split('_').join(' ')+'</label>');
				$('#content').append('<textarea id="content_'+section+'" name="content['+section+
					']" class="mc_content editor simple">'+(mc_values[section] || sections[section])+'</textarea>');
			}
			ckeditor($('.mc_content'));
		});

	});

	$('.delete_page').click(function(e) {
		e.preventDefault();
		$('.lightbox-overlay').fadeIn();
		$('.deletebox').fadeIn();
		$('.deletebox .delete').attr('href', $(this).attr('href'));
	});
	$('.send_button').click(function(e) {
		e.preventDefault();
		$('.lightbox-overlay').fadeIn();
		$('.sendbox').fadeIn();
		$('.sendbox .send').attr('href', $(this).attr('href'));
	});

	autocomplete($('.autocomplete:not(thead .autocomplete)'));
	tagit($('.tags:not(thead .tags)'));
	datepicker($('.date:not(thead .date)'));
	multiselect($('.multiselect:not(thead .multiselect)'));
	toggle($('.toggle a:not(thead .toggle a)'));
	ckeditor($('textarea.editor'));

});
